import React from 'react';

import { Pill } from 'ui-components/components/pill';
import { noop } from 'ui-components/default-props/noop';

import { SuggestAlternativeRatePopover } from './suggest-alternative-rate-popover';
import OrderNumberLink from '../../../components/order-number-link';
import { useContainsDemoOrder } from '../../../demos/hooks/use-contains-demo-order';
import { DEMO_TAG_COLOR, DEMO_TAG_TEXT } from '../constants';
import style from '../style.module.less';

/**
 * @typedef SavingsObject
 * @type {object}
 * @param {number} props.savings.value - The value of the savings.
 * @param {string} props.savings.code - The currency code of the savings.
 */
/**
 * @param {object} props
 * @param {string} props.orderNumberStyle
 * @param {JSX.Element} props.orderNumber
 * @param {string} props.fulfillmentPlanId
 * @param {string} props.salesOrderId
 * @param {boolean} props.isDisabled
 * @param {boolean} props.showAlternativeRate
 * @param {string} props.alternateServiceName
 * @param {SavingsObject} props.savings
 * @param {() => void} props.saveConfiguration
 * @param {boolean} props.isFirstSalesOrderId
 * @param {() => void} props.onPopOverOpen - The function to run when icon clicked.
 * @param {React.ReactNode} props.fraudIcon - Fraud indicator icon with tooltip. Rendered when Loss Prevention feature is enabled and the order has fraud detection indicators. Null otherwise.
 * @returns {JSX.Element}
 */

export const SingleOrderNumberWithAlternativeRate = ({
  orderNumber,
  fulfillmentPlanId,
  salesOrderId,
  orderNumberStyle = undefined,
  isDisabled = false,
  showAlternativeRate = false,
  alternateServiceName = undefined,
  savings = undefined,
  saveConfiguration = noop,
  isFirstSalesOrderId = false,
  onPopOverOpen = noop,
  fraudIcon = null,
}) => {
  const isDemo = useContainsDemoOrder([fulfillmentPlanId]);
  return (
    <div className={orderNumberStyle}>
      <OrderNumberLink
        id={fulfillmentPlanId}
        isOutdated={isDisabled}
        orderNumber={orderNumber}
        salesOrderId={salesOrderId}
        selectGridWhenClicked
      />
      {isDemo ? <Pill className={style['demo-pill']} color={DEMO_TAG_COLOR} label={DEMO_TAG_TEXT} /> : null}
      {showAlternativeRate && !isFirstSalesOrderId ? (
        <SuggestAlternativeRatePopover
          alternateServiceName={alternateServiceName}
          onPopOverOpen={onPopOverOpen}
          saveConfiguration={saveConfiguration}
          savings={savings}
        />
      ) : null}
      {fraudIcon}
    </div>
  );
};
